export default "__VITE_ASSET__D$nu$Ezd__"